<template>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-toolbar color="#3F3FFF">
          <v-toolbar-title>All Posts Summary</v-toolbar-title>
          <v-spacer></v-spacer>
          ({{totalCount}}) Total
        </v-toolbar>
        <v-list two-line subheader color="background-white">
          <v-list-item v-for="(item, i) in summaryList" @click="changeRoute(item)" :key="i">
            <v-list-item-avatar>
              <v-icon>{{item.aIcon}}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <span class="title">{{item.value}}</span>
                {{item.value >= 2 ? 'Posts' : 'Post'}}
              </v-list-item-title>
              <v-list-item-subtitle>{{item.title}}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon ripple>
                <v-icon>keyboard_arrow_right</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import config from '@/config';
import PostAPI from '../Post/postApi';

export default {
  props: {},
  computed: {},
  data() {
    return {
      totalCount: 0,
      summaryList: [
        {
          status: config.postStatus.AD_STRATEGIST_PENDING,
          aIcon: 'assignment_turned_in',
          title: 'Submitted to Kobe',
          value: 0,
          path: `${this.getPath()}/pending-kobe`
        },
        {
          status: config.postStatus.CLIENT_PENDING,
          aIcon: 'watch_later',
          title: 'Pending for Approval',
          value: 0,
          path: `${this.getPath()}/pending-client`
        },
        {
          status: config.postStatus.APPROVE,
          aIcon: 'verified_user',
          title: 'Scheduled to Publish',
          value: 0,
          path: `${this.getPath()}/approved`
        },
        {
          status: config.postStatus.LIVE,
          aIcon: 'cloud_done',
          title: 'Ongoing Posts',
          value: 0,
          path: `${this.getPath()}/published`
        }
        // {
        //   status: config.postStatus.COMPLETE,
        //   aIcon: 'archive',
        //   title: 'Completed Posts',
        //   value: 0,
        //   path: '/posts/completed'
        // }
      ]
    };
  },
  methods: {
    changeRoute(item) {
      this.$router.push({ path: item.path });
    },
    getPath() {
      const role = this.$store.state.user.role;
      return role === config.userRoles.INFLUENCER || role === config.userRoles.CLIENT ? '/posts' : '/posts/internal';
    },
    fetchPosts() {
      for (let pStatus in config.postStatus) {
        let status = config.postStatus[pStatus];
        PostAPI.getPost({ status, page: 1 })
          .then(response => {
            let posts = response.posts;
            this.summaryList.forEach(item => {
              if (item.status === status) {
                item.value = posts.length;
                this.totalCount += posts.length;
              }
            });
          })
          .catch(err => {
            console.error(err);
          });
      }
    }
  },
  mounted() {
    this.fetchPosts();
  }
};
</script>
<style>
.background-white {
  background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// PostsSummary.vue?0961f398